export const TAILLES = ["Moins de 20", "20 à 99", "100 à 499", "500 et plus"];
export const TERRITOIRES = ["Québec", "France", "Belgique", "Suisse"];
export const ETATS = ["À amorcer", "En réflexion", "En cours", "Bien structurée, à consolider"];
export const PRIORITES = [
  "Climat et cohésion d'équipe",
  "Charge des gestionnaires",
  "Rétention des talents",
  "Présence au travail",
  "Documenter la démarche de prévention",
  "Posture et énergie de la direction",
  "Période de croissance ou de transition",
  "Autre",
];
export const ECHEANCES = ["D'ici 3 mois", "D'ici 6 mois", "Avant 2027", "Plus tard"];
export const DECIDEURS = ["Moi-même", "La direction", "Les RH", "Un comité"];
export const FORMATS = [
  "Accompagnement de la direction",
  "Atelier pour les gestionnaires",
  "Audit de la démarche de prévention",
  "Webinaire d'information",
  "À explorer ensemble",
];
export const CONTACTS = ["Courriel", "WhatsApp", "Appel de 15 min", "Visio de 30 min"];
export const MOMENTS = ["Matin", "Midi", "Après-midi", "Fin de journée"];

export const INITIAL = {
  nom: "", fonction: "", organisation: "", secteur: "", courriel: "", telephone: "",
  taille: "", territoire: "", etat_demarche: "", priorites: [], priorite_autre: "",
  situation: "", vision_6_mois: "", deja_en_place: "", echeance: "", decideurs: [],
  formats: [], contact_prefere: "", moment: "", consentement: false, site_web: "",
};

export const PREFILL = ["nom", "courriel", "organisation", "fonction", "telephone"];
